import React, { useEffect } from "react";

//Import Icons
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { MdPhoneInTalk } from "react-icons/md";

//Import AOS
import AOS from "aos";
import "aos/dist/aos.css";

//Import Logo
import logo from "../../assets/images/DSS.png";

const Footer = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: false,
      offset: 100, // Trigger when the element is 100px from the viewport
      delay: 200, // Whether animation should happen only once
    });
  }, []);

  return (
    <div className="bg-[#E8F4FA] mt-10 md:mt-20">
      <div className="mx-8 md:mx-12 pb-6 grid grid-cols-1 lg:grid-cols-3 gap-10 border-b-2 border-[#B2B2B2]">
        {/* Company Logo & Social */}
        <div className="xl:pr-12" data-aos="zoom-in-up">
          <div className="w-16 md:w-20 lg:w-28 my-6">
            <img src={logo} alt="DSS logo" className="h-auto w-auto" />
          </div>
          <div className="mb-6">
            <p className="text-[#252525] font-light oxygen md:text-lg text-sm">
              Drive Safe Solutions is the ideal option to travel without fuss on
              national highways, it facilitates automatic deduction of toll fees
              and allows you to pass through the toll plaza without stopping to
              pay in cash.
            </p>
          </div>
          <div className="flex gap-3 mb-4">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F26422] bg-white h-10 w-10 p-3 rounded-full shadow-xl"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F26422] bg-white h-10 w-10 p-3 rounded-full shadow-xl"
            >
              <FaInstagram />
            </a>

            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F26422] bg-white h-10 w-10 p-3 rounded-full shadow-xl"
            >
              <FaTwitter />
            </a>

            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F26422] bg-white h-10 w-10 p-3 rounded-full shadow-xl"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Contact & Address */}
        <div
          className=" lg:mx-2 xl:mx-12 flex flex-col gap-4 justify-center "
          data-aos="zoom-in-down"
        >
          <h1 className="text-[#252525] font-bold md:text-xl oxygen">
            Contact Us
          </h1>
          <div className="flex flex-col gap-4">
            <div className="flex gap-4 items-center">
              <div className="text-[#F26422] bg-white p-2 h-8 w-8 flex items-center justify-center rounded-full shadow-xl">
                <IoLocationSharp />
              </div>
              <>
                {/* <p className="text-[#252525] text-sm md:text-base capitalize oxygen">
                  NH-16, Jaraka Bus Stop S.R Market Complex Ground Floor Room
                  No-230 Jaraka, Dharmasala, Jajpur Odisha-755050
                </p> */}
                <p className="text-[#252525] text-sm md:text-base capitalize oxygen">
                  Floor No: KHATA NO-88, <br />
                  PLOT No-161, Betamalisasan, <br />
                  Near HANUMAN TEMPLE, Antia, Jajpur, Odisha, 755023
                </p>
              </>
            </div>

            <div className="flex gap-4 items-center">
              <div className="text-[#F26422] bg-white h-8 w-8 p-2 flex items-center justify-center rounded-full shadow-xl">
                <IoIosMail />
              </div>
              <>
                <a
                  href="mailto:drivesafeinfo@gmail.com"
                  className="text-[#252525] text-sm md:text-base oxygen"
                >
                  support@drivesafesolutions.in
                </a>
              </>
            </div>

            <div className="flex gap-4 items-center">
              <div className="text-[#F26422] bg-white h-8 w-8 p-2 flex items-center justify-center rounded-full shadow-xl">
                <MdPhoneInTalk />
              </div>
              <>
                <a
                  href="tel:+918569562365"
                  className="text-[#252525] text-sm md:text-base oxygen"
                >
                  +91 91245 78108
                </a>
              </>
            </div>
          </div>
        </div>

        {/* NewsLetter */}
        <div
          className="xl:ml-20 flex flex-col gap-4 justify-center "
          data-aos="zoom-in-up"
        >
          <h1 className="text-[#252525] font-bold md:text-xl oxygen">
            News Letter
          </h1>
          <p className="text-[#252525] font-light text-sm md:text-lg oxygen">
            Subscribe our newsletter to get our latest updates & news{" "}
          </p>
          <>
            <input
              type="email"
              placeholder="Enter your email address"
              className="p-2 md:p-4 w-full rounded-md border-2 border-[#DCE0EB] outline-none"
            />
            <button
              type="submit"
              className="bg-[#252525] text-white p-3 rounded-md w-1/2 hover:bg-[#434040]"
            >
              Subscribe
            </button>
          </>
        </div>
      </div>

      {/* Copyright & Policy */}

      <div className="mx-8 md:mx-12 py-4 flex flex-col md:flex-row justify-between items-center">
        <p className="text-center text-[#000000] text-xs lg:text-base poppins">
          Copyright© 2023 DriveSafe Solutions. All rights reserved.
        </p>
        <div className="flex gap-4">
          <p className="text-center text-[#000000] text-xs lg:text-base poppins cursor-pointer">
            Terms & Conditions
          </p>
          <p className="text-center text-[#000000] text-xs lg:text-base poppins cursor-pointer">
            Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
